import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '../../../services/language/language.service';

@Pipe({
  name: 'limitLabel',
  standalone: false
})
export class LimitLabelPipe implements PipeTransform {
  constructor(private readonly languageService: LanguageService) {}

  transform(limitCode: string | null | undefined): string {
    if (!limitCode) {
      return '';
    }
    const key = `usage.limit.${limitCode}`;
    const translated = this.languageService.translate(key);
    if (translated && translated !== key) {
      return translated;
    }
    return limitCode.replace(/_/g, ' ');
  }
}
